import React from 'react'

import { useAuth } from '../hooks/useAuth'

import PageLoading from './PageLoading'
import Unauthorized from './Unauthorized'


interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRoles?: string[]
}

export default function ProtectedRoute({ children, requiredRoles = [] }: ProtectedRouteProps) {
  const { isAuthenticated, hasAnyRole, roles, loading } = useAuth()

  // Show loading spinner while checking authentication
  if (loading) {
    return <PageLoading />
  }

  // User is not authenticated
  if (!isAuthenticated) {
    return <Unauthorized />
  }

  // User is authenticated but has no required roles
  if (!hasAnyRole) {
    return <Unauthorized />
  }

  // If specific roles are required, check if user has any of them
  if (requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some((role) => roles.includes(role))
    if (!hasRequiredRole) {
      return <Unauthorized />
    }
  }

  // User is authorized, render the protected content
  return <>{children}</>
}
